<div
  class="margin-top-24 text-align-center"
  [ngClass]="contrast"
  [ngStyle]="{ opacity: opacity }"
>
{{ label }} {{ env.appVersion }}-{{ env.env }}
</div>
